import "bootstrap/dist/css/bootstrap.min.css";
import { Image} from "react-bootstrap";
import OurBoardMemberImageOne from "../../../../assests/images/about-great-non-profit-image/olivia-khalili.webp";
import {
    OurBoardMembersContent,
    OurBoardMembersBox,
    OurBoardMembersImage,
    OurBoardMembersTitle,
    OurBoardMembersText
} from "./OurBoardMembersStyle"

const OurBoardMembers = ({memberDetail}:any) => {
    return (
        <OurBoardMembersBox className="board-member-box">
            <OurBoardMembersImage>
                <Image src={OurBoardMemberImageOne} alt={memberDetail?.profileImg}/>
            </OurBoardMembersImage>

            <OurBoardMembersContent>
                <OurBoardMembersTitle className="member-name">{memberDetail?.name}</OurBoardMembersTitle>
                <OurBoardMembersText>{memberDetail?.profession}</OurBoardMembersText>
            </OurBoardMembersContent>
        </OurBoardMembersBox>
    )
};
export default OurBoardMembers;